import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { not } from 'ember-truth-helpers';
import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Table from 'umg-ember-backend/components/record-explorer/table';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';
import { getBem } from 'umg-ember-backend/utils/get-bem';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

import styles from './styles.module.css';

const bem = getBem(styles);

export const SCANNER_TYPES = ['website', 'shop', 'stage+'];

export default class RecordDetailFormsA11yScannerComponent extends Component {
  // Services
  @service breadcrumb;
  @service data;
  @service router;

  // Defaults
  scanIntervals = ['weekly', 'monthly'];
  types = SCANNER_TYPES;
  tableColumns = [
    {
      property: 'lastScanStart',
      type: 'date',
      format: 'L LT',
    },
    {
      property: 'lastScanEnd',
      type: 'date',
      format: 'L LT',
    },
    {
      property: 'violationsA',
    },
    {
      property: 'violationsAA',
    },
    {
      property: 'violationsAAA',
    },
    {
      property: 'violationsTotal',
    },
    {
      property: 'scoreTotal',
    },
    {
      property: 'statusLabel',
    },
  ];

  // Getter and setter
  get scanIntervalOptions() {
    return labelValueOptions.call(this, this.scanIntervals, [
      'forms.a11y-scanner.options.scanInterval',
    ]);
  }

  get typeOptions() {
    return labelValueOptions.call(this, this.types, [
      'forms.a11y-scanner.options.type',
    ]);
  }

  get countryOptions() {
    return this.resolvedCountries.value ?? [];
  }

  // Functions
  openReportList = (record) => {
    if ([3, 4].includes(record.status)) {
      this.flashMessages.warning(
        'record_detail.for.a11y_scanner.archived_scan',
      );
      return;
    }
    const route = this.breadcrumb.registerExplorerRoute('a11y-report', {
      queryParams: { scan: record.id },
    });

    this.router.transitionTo(...route.transitionToParams);
  };

  // Functions
  resolvedCountries = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'COUNTRY' });
  });

  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='domain' />
          </form.fieldset>

          <Table
            @columns={{this.tableColumns}}
            @records={{form.model.scans}}
            @recordType='a11y-scan'
            @recordActions={{hash edit=this.openReportList}}
            class={{bem 'table'}}
          />
        </:content>
        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @isSearchEnabled={{true}}
              @labelProperty='name'
              @options={{this.countryOptions}}
              @property='country'
              @searchField='name'
              @selectPath='shortName'
              @type='select-value'
            />
            <fieldset.field
              @property='type'
              @type='select-value'
              @options={{this.typeOptions}}
            />
            <fieldset.field @property='recurringScan' @type='checkbox' />
            <fieldset.field
              @property='scanInterval'
              @type='select-value'
              @options={{this.scanIntervalOptions}}
              @disabled={{not form.model.recurringScan}}
            />
            <fieldset.field @property='urlsToScan' @type='textarea' />
          </form.fieldset>
          <form.sections.meta />
        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
